import { BodyText } from '@farol-ds/react'

import { LoginCard } from '../../login-card'

export interface EmailChangeSentProps {
  email: string
}

export function EmailChangeSent({ email }: EmailChangeSentProps) {
  const header = { title: 'Confirme seu novo e-mail' }

  return (
    <LoginCard header={header} hideCloseButton>
      <BodyText size="md">
        Caso o endereço de e-mail esteja disponível, enviaremos um e-mail para o endereço{' '}
        <strong>{email}</strong> para ativá-lo. Caso não tenha recebido, confira a caixa de spam. A
        alteração será concluída assim que você confirmar esta operação.
      </BodyText>
    </LoginCard>
  )
}
